// eslint-disable max-len
export default {
    ADD_TO_CART: 'Add to cart',
    ADD_TO_WISHLIST: 'Add to wishlist',
    APPLY: 'Apply',
    CALL_US: 'Call us',
    CANCEL: 'Cancel',
    CHOOSE_OPTION: 'Choose an option',
    COMPLETED: 'Completed',
    COMPONENTS: 'Components',
    COPY: 'Copy link to design',
    COPIED: 'Link copied to clipboard',
    CUSTOMER_SERVICE: 'Our Customer Service Team is ready to help.',
    DETAILS: 'details',
    DIFFERENT_SIZE: 'Different size for each foot?',
    DONE_FOR_NOW: 'Done customizing for now?',
    EMAIL: 'Email',
    EMAIL_DESIGN: 'Email design',
    EMAIL_INVALID: 'Please enter a properly formatted email address.',
    EMAIL_SENT: 'Thank You! A link to your customized MyJoys has been sent to your friend.',
    EMAIL_SUMMARY: 'MyJoys: Email Summary',
    ENTER_EMBROIDERY: 'Enter Custom Embroidery',
    HELP: 'Help',
    HOURS: 'M-Th 8:00 AM to 5:00 PM ET, \n F 8:30 AM to 5:00 PM ET',
    INVALID_ERROR: 'This field contains an invalid phrase',
    MAKE_A_SELECTION: 'Make a selection to continue',
    MAX_LENGTH_6: 'Max 6 characters allowed for Block',
    MAX_LENGTH_3: 'Max 3 characters allowed for Script',
    MENS: 'Men\'s',
    MESSAGE: 'Message',
    MESSAGE_US: 'Message Us',
    NEED_HELP: 'Need help?',
    NONE_SELECTED: 'None Selected',
    OK: 'Ok',
    PERSONALIZATION_POLICY: 'Personalization Policy',
    PHONE_NUMBER: '8002248501',
    PHONE_NUMBER_FORMATTED: '(800) 224-8501',
    PRINT: 'Print design',
    RECIPIENT_NAME: 'Recipient\'s Name',
    RECIPIENT_EMAIL: 'Recipient\'s Email',
    REQUIRED: 'This field is required',
    RESET: 'Reset',
    RESET_CONFIRM: 'Would you like to reset all selections?',
    RESET_CONFIRM_COPY: 'If you continue, all selections will be reset and your design will be started over from scratch.',

    SAVE: 'Save',
    SAVE_EXIT: 'Save & Exit',

    SELECT_SIZE: 'Select Size',
    SELECT_WIDTH: 'Select Width',
    LEFT_SHOE_SIZE: 'Left Shoe Size',
    RIGHT_SHOE_SIZE: 'Right Shoe Size',

    SEND_COPY: 'Send me a copy of this email too',
    SHARE: 'Share',
    SHARE_DESIGN: 'Share your design',
    SIZE_GUIDE: 'Size Guide',
    SUBMIT: 'Submit',
    UNDO: 'Undo',
    VIEW_ALL: 'View All',
    WEVE_GOT_YOU: 'We\'ve got you covered! If you leave this page, your MyJoys selections will be saved in your designs to continue later.',
    WOMENS: 'Women\'s',
    YOUR_NAME: 'Your Name',
    YOUR_EMAIL: 'Your Email',
    BACKORDERED: 'Size is backordered and available to order after {date}',
    INSTANCE_ERROR_HEADER: 'Error saving your selections',
    INSTANCE_ERROR_BODY: 'We are currently unable to save your selections. Please try again shortly.',
    UPDATE_CART: 'Update Cart',
    PERSONALIZE_CHOOSE_OPTION: 'Choose an option',
    PERSONALIZE_SAME_LEFT: 'Same on left side',
    PERSONALIZE_SAME_RIGHT: 'Same on right side',
    PERSONALIZE_NONE: 'None',
    PERSONALIZE_LOGO: 'Logo',
    PERSONALIZE_MONOGRAM: 'Monogram',
    MONOGRAM_COLOR: 'Monogram Color',
    NOT_AVAILABLE_BODY: 'The product you are trying to access is unavailable.',
    NOT_AVAILABLE_HEADER: 'Not Available',
    VENDOR_LOGOS: 'Account Specific',
};
